import React from 'react'
import { UIBadge, type UIBadgeProps } from './ui-badge'
import { cn } from '../../lib/utils'

export interface UIBadgeClickableProps extends UIBadgeProps {
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

/**
 * UIBadgeClickable - Clickable Badge Block
 * 클릭 가능한 배지 컴포넌트입니다.
 * Badge 기반으로 asChild를 활용하여 button 요소로 렌더링합니다.
 */
export const UIBadgeClickable = React.forwardRef<HTMLButtonElement, UIBadgeClickableProps>(
  ({ onClick, className, children, ...props }, ref) => (
    <UIBadge
      asChild
      className={cn("cursor-pointer hover:opacity-80 transition-opacity", className)}
      {...props}
    >
      <button ref={ref} onClick={onClick} type="button">
        {children}
      </button>
    </UIBadge>
  )
)

UIBadgeClickable.displayName = "UIBadgeClickable"